import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';

import { addDislikedProduct, updateDislikedProduct } from '../../actions/product';
import ModalWrapper from '../ModalWrapper/ModalWrapper';
import styles from './DislikedProductModal.module.css';

const DislikedProductModal = (props) => {
  const { 
    initialValue, 
    isOpen, 
    onClose,
    addDislikedProduct,
    updateDislikedProduct,
    productsData,
  } = props;

  const [name, setName] = useState('');  

  // console.log('===initialValue', initialValue);

  useEffect(() => {
    setName(initialValue?.name);
  }, [isOpen, initialValue]);

  const title = initialValue ? 'Edit disliked product' : 'Add new disliked product';

  const changeValueHandler = setter => event => {
    setter(event.target.value);
  };

  const onSaveHandler = () => {
    const trimmedName = name.trim();
    if (!trimmedName) {
      return toast.error('Name is required', {
        position: 'bottom-right',
        duration: 3000,
      });
    }

    // Check if there is an allergy with the same name and unit type
    const existenceAllergy = productsData.find(allergy => {
      if (allergy.name !== trimmedName) {
        return false;
      }

      return initialValue?.id !== allergy.id;
    });

    if (existenceAllergy) {
      return toast.error('Product with this name already exists', {
        position: 'bottom-right',
        duration: 3000,
      }); 
    }

    const allergyData = {
      name: trimmedName,
    };

    if (initialValue) {
      allergyData.id = initialValue.id;
      updateDislikedProduct(allergyData);
    } else {
      addDislikedProduct(allergyData);
    }

    onClose();
  };

  return (
    <ModalWrapper 
      isOpen={isOpen} 
      onClose={onClose} 
      onSave={onSaveHandler} title={title}
    >
      <div className={styles.wrapper}>
        <label className={styles.row}>
          <span>Product name</span>
          <input 
            className={styles.input} 
            onChange={changeValueHandler(setName)}
            placeholder="Product name"
            value={name}
          />
        </label>
      </div>
    </ModalWrapper>
  );
};

const mapStateToProps = (store) => ({
  productsData: store.product.dislikedProductsData,
});

const mapDispatchToProps = {
  addDislikedProduct,
  updateDislikedProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(DislikedProductModal);